module.exports = __webpack_public_path__ + "img/UTFREM-14.45e80419.jpg";